var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('YourAccountEmail',{attrs:{"nextUrl":_vm.nextUrl,"backUrl":_vm.backUrl,"redirectUrl":_vm.redirectUrl,"analyticsPrefix":"AI"}})}
var staticRenderFns = []

export { render, staticRenderFns }